// import React, { useState } from "react";
import {
  Box,
  // Stepper,
  // Step,
  // StepLabel,
  // Button,
  // Typography,
  // Stack,
} from "@mui/material";
// import StepOne from "./stepOne";
// import StepThree from "./stepThree"; // This is now Step Two
import BookingForm from "./bookingForm"; // This is now Step Two
// import { submitUserDetails, bookAppointment } from "../../services/bookNow";
// import { v4 as uuidv4 } from "uuid";

// const steps = ["Personal Info", "Review & Submit"];

// const getStepContent = (step, formData, setFormData, setIsNextEnabled) => {
//   switch (step) {
//     case 0:
//       return (
//         <StepOne
//           formData={formData}
//           setFormData={setFormData}
//           setIsNextEnabled={setIsNextEnabled}
//         />
//       );
//     case 1:
//       return <StepThree formData={formData} setFormData={setFormData} />;
//     default:
//       return null;
//   }
// };

const MultiStepForm = () => {
  // const [activeStep, setActiveStep] = useState(0);
  // const [isNextEnabled, setIsNextEnabled] = useState(false);
  // const [formData, setFormData] = useState({
  //   firstName: "",
  //   lastName: "",
  //   emailAddress: "",
  //   contactNumber: "",
  //   dateOfBirth: "",
  //   category: "",
  //   dob: "",
  //   organizationName: "",
  //   industryName: "",
  //   taxFileNumber: "",
  //   abnNumber: "",
  //   serviceCategory: "",
  //   serviceSubCategory: "",
  //   selectedAgent: null,
  //   selectedDate: null,
  //   selectedTimeSlot: null,
  //   marketingConsent: false,
  //   dataShareConsent: false,
  //   selectAgentOption: "", // keep this to track "yes"/"no"
  // });

  // const handleNext = () => {
  //   if (activeStep === steps.length - 1) {
  //     handleFinalSubmit();
  //   } else {
  //     setActiveStep((prevActiveStep) => prevActiveStep + 1);
  //     setIsNextEnabled(false);
  //   }
  // };

  // const handleBack = () => {
  //   setActiveStep((prevActiveStep) => prevActiveStep - 1);
  //   setIsNextEnabled(false);
  // };

  // const handleReset = () => {
  //   setActiveStep(0);
  //   setIsNextEnabled(false);
  //   setFormData({
  //     firstName: "",
  //     lastName: "",
  //     emailAddress: "",
  //     contactNumber: "",
  //     dateOfBirth: "",
  //     category: "",
  //     dob: "",
  //     organizationName: "",
  //     industryName: "",
  //     taxFileNumber: "",
  //     abnNumber: "",
  //     serviceCategory: "",
  //     serviceSubCategory: "",
  //     selectedAgent: null,
  //     selectedDate: null,
  //     selectedTimeSlot: null,
  //     marketingConsent: false,
  //     dataShareConsent: false,
  //     selectAgentOption: "",
  //   });
  // };

  // const handleFinalSubmit = async () => {
  //   try {
  //     const userId = uuidv4();

  //     await submitUserDetails({
  //       userId,
  //       firstName: formData.firstName,
  //       lastName: formData.lastName,
  //       email: formData.emailAddress,
  //       phoneNumber: formData.contactNumber,
  //       dateOfBirth: formData.dateOfBirth,
  //       category: formData.category,
  //       dob: formData.dob,
  //       organizationName: formData.organizationName,
  //       industryName: formData.industryName,
  //       taxFileNumber: formData.taxFileNumber,
  //       abnNumber: formData.abnNumber,
  //       serviceCategory: formData.serviceCategory,
  //       serviceSubCategory: formData.serviceSubCategory,
  //       marketingConsent: formData.marketingConsent,
  //       dataShareConsent: formData.dataShareConsent,
  //     });
  //     console.log('Form Data',formData)

  //     if (formData.selectedDate && formData.selectedTimeSlot) {
  //       await bookAppointment({
  //         agentId: formData?.selectedAgent?.agentId,
  //         userId,
  //         date: formData.selectedDate.toISOString(),
  //         slotTime: formData.selectedTimeSlot,
  //       });
  //       setActiveStep((prevActiveStep) => prevActiveStep + 1);
  //     } else {
  //       alert("Please complete all required fields before submitting");
  //     }
  //   } catch (error) {
  //     console.error("Error during final submission:", error);
  //     alert("Failed to complete your booking. Please try again.");
  //   }
  // };

  // const isStepValid = (step) => {
  //   switch (step) {
  //     case 0:
  //       return isNextEnabled;
  //     case 1:
  //       return (
  //         formData.selectedDate !== null && formData.selectedTimeSlot !== null
  //       );
  //     default:
  //       return true;
  //   }
  // };

  return (
    <Box sx={{ width: "100%", mt: 5 }}>
      {/* <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <Box sx={{ my: 4 }}>
        {activeStep === steps.length ? (
          <Stack spacing={2} alignItems="center">
            <Typography variant="h6">
              Appointment Successfully Booked!
            </Typography>
            <Typography>
              Thank you for booking your appointment. You will receive a
              confirmation email shortly.
            </Typography>
            <Button variant="contained" onClick={handleReset}>
              Book Another Appointment
            </Button>
          </Stack>
        ) : (
          <Stack spacing={3}>
            {getStepContent(
              activeStep,
              formData,
              setFormData,
              setIsNextEnabled
            )}
            <Stack direction="row" spacing={2} justifyContent="space-between">
              <Button disabled={activeStep === 0} onClick={handleBack}>
                Back
              </Button>
              <Button
                variant="contained"
                onClick={handleNext}
                disabled={!isStepValid(activeStep)}
              >
                {activeStep === steps.length - 1 ? "Finish" : "Next"}
              </Button>
            </Stack>
          </Stack>
        )}
      </Box> */}
      <BookingForm></BookingForm>
    </Box>
  );
};

export default MultiStepForm;
